import React from "react";
import { Field } from "react-final-form";
import { FieldRequiredError } from "@syos-music/form";

import MarkdownInput from "components/form/MarkdownInput";

export default function MarkdownField({ required, validate, ...props }) {
  return (
    <Field
      type="select"
      component={MarkdownInput}
      required={required}
      validate={(value, ...args) => {
        if (required && !value) return <FieldRequiredError />;
        return validate(value, ...args);
      }}
      {...props}
    />
  );
}

MarkdownField.defaultProps = {
  validate: () => {},
};
